/***
 * 开关合集，（需确保登录后初始化完毕方可使用）1
 */
const travel = () => {
  return $ZConfig.getVal('TM_PLAN_SWITCH_COMPANY') && $ZConfig.getVal('TM_PLAN_SWITCH_EMPLOYEE')
}
const travelNew = () => {
  return $ZConfig.getVal('TM_PLAN_SWITCH_COMPANY')
}
// 国内机票：因公&职级开 或因私开
const flight = () => {
  return (
    ($ZConfig.getVal('OTA_FLIGHT_D_SWITCH_COMPANY') && $ZConfig.getVal('OTA_FLIGHT_D_SWITCH_EMPLOYEE')) ||
    $ZConfig.getVal('OTA_FLIGHT_D_P_SWITCH_COMPANY')
  )
}
// 国际机票：因公&职级开 或因私开
const flightIntl = () => {
  return (
    ($ZConfig.getVal('OTA_FLIGHT_I_SWITCH_COMPANY') && $ZConfig.getVal('OTA_FLIGHT_I_SWITCH_EMPLOYEE')) ||
    $ZConfig.getVal('OTA_FLIGHT_I_P_SWITCH_COMPANY')
  )
}
// 酒店：因公&职级开 或因私开
const hotel = () => {
  return (
    ($ZConfig.getVal('OTA_HOTEL_D_SWITCH_COMPANY') && $ZConfig.getVal('OTA_HOTEL_D_SWITCH_EMPLOYEE')) ||
    $ZConfig.getVal('OTA_HOTEL_D_P_SWITCH_COMPANY')
  )
}
// 火车：因公&职级开 或因私开
const train = () => {
  return (
    ($ZConfig.getVal('OTA_RAILWAY_D_SWITCH_COMPANY') && $ZConfig.getVal('OTA_RAILWAY_D_SWITCH_EMPLOYEE')) ||
    $ZConfig.getVal('OTA_RAILWAY_D_P_SWITCH_COMPANY')
  )
}
// 用车：公司开启
const car = () => {
  return $ZConfig.getVal('OTA_CAR_SWITCH_COMPANY')
}

export default {
  // 差旅计划是否可用
  travel,
  travelNew,
  // 总开关国内机票是否可用
  flight,
  // 总开关国际机票是否可用
  flightIntl,
  // 总开关酒店是否可用
  hotel,
  // 总开关火车是否可用
  train,
  // 用车是否可用
  car
}
